import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {LoginComponent} from "./+login/login.component";

@NgModule({
  imports: [
    RouterModule.forChild([
      // { path: '', redirectTo: '/home', pathMatch: 'full' },
      { path: 'login', component: LoginComponent }
    ])
  ],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/app-routing.module.ts